// extracted by mini-css-extract-plugin
var _1 = "BankAccountBoxStyle-module__box-mobile___LwBlG";
var _2 = "BankAccountBoxStyle-module__box-mobile___LwBlG";
var _3 = "BankAccountBoxStyle-module__btn-holder___CZMOq";
var _4 = "BankAccountBoxStyle-module__btn-holder___CZMOq";
var _5 = "BankAccountBoxStyle-module__details___qRjXE";
var _6 = "BankAccountBoxStyle-module__from-this-label___GpShO";
var _7 = "BankAccountBoxStyle-module__from-this-label___GpShO";
var _8 = "BankAccountBoxStyle-module__requested-details___GeSAu";
var _9 = "BankAccountBoxStyle-module__requested-label___XhMy4";
var _a = "BankAccountBoxStyle-module__requested-details___GeSAu";
var _b = "BankAccountBoxStyle-module__requested-label___XhMy4";
var _c = "BankAccountBoxStyle-module__table___JJ1A8";
export { _1 as "box-mobile", _2 as "boxMobile", _3 as "btn-holder", _4 as "btnHolder", _5 as "details", _6 as "from-this-label", _7 as "fromThisLabel", _8 as "requested-details", _9 as "requested-label", _a as "requestedDetails", _b as "requestedLabel", _c as "table" }
